// FIXME: Update this file to be type safe and remove this and next line
// @ts-strict-ignore
export class SharedFolder {
  id: string;
  name: string;
  encryptionKey: Uint8Array;
}
